/**
 * Creates a filter handler function for the dropdown
 * @returns The filter handler function
 */
// eslint-disable-next-line import/prefer-default-export
export const dropdownFilterHandler = (
  item: any,
  searchText: string
): boolean => {
  if (!searchText || searchText.trim() === '') return true;

  if (item.label === 'empty') return false;

  if (item.value) {
    const itemName = item.value.name || item.label || '';
    return itemName.toLowerCase().includes(searchText.toLowerCase());
  }

  return false;
};
